import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../../service/apiServices";

const namespace = "DepStaDetails";

export const postDepStaDetailsReport = createAsyncThunk(
  `${namespace}/postDepStaDetails`,
  async (body, { rejectWithValue }) => {
    const api = "departmentdetail";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const postDepStaDetailsExcel = createAsyncThunk(
  `${namespace}/postDepStaDetailsExcel`,
  async (body, { rejectWithValue }) => {
    const api = "depstadetailsexcel";
    const opt = {
      body:body ,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
const initialState = {
  depStaDetailsReport: {
    yearMonth: "",
    year: " ",
    month: " ",
  },
};

const depStaDetailsSlice = createSlice({
  name: "depStaDetails",
  initialState,
  reducers: {
    updateDepStaDetailsReport(state, action) {
      return { ...state, depStaDetailsReport: action.payload };
    },
    resetDepStaDetailsReport(state, action){
      return{...state, depStaDetailsReport: initialState.depStaDetailsReport};
    },
  },
  extraReducers: {
    [postDepStaDetailsReport.pending]: (state, action) => {
      state.loading = true;
    },
    [postDepStaDetailsReport.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [postDepStaDetailsReport.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [postDepStaDetailsExcel.pending]: (state, action) => {
      state.loading = true;
    },
    [postDepStaDetailsExcel.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [postDepStaDetailsExcel.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
  },
});

export const { updateDepStaDetailsReport, resetDepStaDetailsReport } = depStaDetailsSlice.actions;
export default depStaDetailsSlice.reducer;
